// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2l56g","rootNoMargin":"styles_rootNoMargin__23sH8"};